// src/constants/gfm.js
// GFM sites: `key` is what the API and stored data use, `label` is what people see.
export const GFM_SITES = [
  { key: 'main',      label: 'Main' },
  { key: 'guildford', label: 'Guildford' },
  { key: 'northern',  label: 'Northern' },
  { key: 'vision7',   label: 'Vizion 7' },
];

export const GFM_SITE_KEYS = GFM_SITES.map(s => s.key);

export function siteLabel(key = '') {
  const k = String(key).toLowerCase();
  const hit = GFM_SITES.find(s => s.key === k);
  if (hit) return hit.label;
  return k ? k[0].toUpperCase() + k.slice(1) : '';
}

// Suppliers offered in the GFM order dropdowns. "Other" lets people type one in.
export const GFM_SUPPLIERS = ['Amazon', 'Essex Supplies', 'Altec', 'Agrigem'];

/** Returns the listed supplier matching `name` (case-insensitive), or '' if none. */
export function matchSupplier(name = '') {
  const n = String(name).trim().toLowerCase();
  return GFM_SUPPLIERS.find(s => s.toLowerCase() === n) || '';
}
